<template>
  <div>
    <div class="pb-4">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex position-relative align-items-center">
          <div
            class="sr__badge sr__badge--sq sr__badge--fix mr-1"
            style="height: 24px;"
            v-if="!recordReviewed && existCheckBoxFieldReviewComments"
          >需修正</div>

          <div
            v-if="checkBoxField.validates?.presence"
            class="sr__content-required"
          >*</div>

          <div
            class="sr__content"
            v-html="checkBoxField.content"
          ></div>

        </div>

        <div
          v-if="checkBoxField.editable && !recordReviewed && (canShowTag || existCheckBoxFieldReviewComments)"
          @click="tag(checkBoxField)"
        >
          <b-icon icon="tags"></b-icon>
        </div>
      </div>

      <CheckboxItem
        :field="checkBoxField"
        :value.sync="checkBoxField.value.value"
        :disable="disable"
      ></CheckboxItem>
    </div>

    <div class="pb-4">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex position-relative align-items-center">
          <div
            class="sr__badge sr__badge--sq sr__badge--fix mr-1"
            style="height: 24px;"
            v-if="!recordReviewed && existOrderFieldReviewComments"
          >需修正</div>

          <div
            v-if="orderField.validates?.presence"
            class="sr__content-required"
          >*</div>

          <div
            class="sr__content"
            v-html="orderField.content"
          ></div>
        </div>

        <div
          v-if="orderField.editable && !recordReviewed && (canShowTag || existOrderFieldReviewComments)"
          @click="tag(orderField)"
        >
          <b-icon icon="tags"></b-icon>
        </div>
      </div>

      <draggable
        v-model="orderFieldValue.value"
        :disabled="disable"
      >
        <div
          v-for="(obj, index) in orderFieldValue.value"
          :key="obj.value"
          style="width: fit-content;"
        >
          <div class="d-inline-flex align-items-center">
            <div class="pr-2">{{index+1}}.</div>
            <div class="sr__drag-item">{{obj.title}}</div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CheckboxItem from './checkboxItem.vue'
import MicroModal from 'micromodal'

export default {
  name: 'OrderItem',
  props: {
    field: Object,
    disable: Boolean,
    canShowTag: Boolean,
    recordReviewed: Boolean
  },
  data () {
    return {
      options: {},
      checkBoxField: {},
      valueOptions: [],
      orderField: {},
      orderFieldValue: {}
    }
  },
  methods: {
    tag (item) {
      this.$store.dispatch('setReviewItem', item)
      MicroModal.show('review-comment-modal')
    }
  },
  computed: {
    existCheckBoxFieldReviewComments () {
      return this.checkBoxField.review_comments?.some(e => !e.checked)
    },
    existOrderFieldReviewComments () {
      return this.orderField.review_comments?.some(e => !e.checked)
    }
  },
  watch: {
    'checkBoxField.value.value': function () {
      var oldOpts = this.orderFieldValue.value.filter((e) => {
        return this.checkBoxField.value.value.indexOf(e.value) !== -1
      })

      var oldValues = oldOpts.map((e) => {
        return e.value
      })

      var newValues = this.checkBoxField.value.value.filter((e) => {
        return oldValues.indexOf(e) === -1
      })

      var newOpts = this.valueOptions.filter((e) => {
        return newValues.indexOf(e.value) !== -1
      })

      this.orderFieldValue.value = oldOpts.concat(newOpts)
    }
  },
  created () {
    this.options = this.field.mix_options

    this.orderField = this.field.value.find(e => e.iden === this.options.order_item)
    this.orderFieldValue = this.orderField.value

    this.checkBoxField = this.field.value.find(e => e.iden === this.options.checkbox_item)
    this.valueOptions = this.checkBoxField.value.value_options || []
  },
  components: {
    draggable,
    CheckboxItem
  }
}
</script>
